/**
 * Пошаговые инструкции «где взять» для ключей сервисов — открываются кнопкой «i» у поля.
 */
const ext = { target: '_blank', rel: 'noopener noreferrer' } as const;

export function TelegramTokenGuide() {
  return (
    <>
      <b>Как получить токен бота</b>
      <ol>
        <li>
          В Telegram откройте{' '}
          <a href="https://t.me/BotFather" {...ext}>
            @BotFather
          </a>{' '}
          — официальный бот Telegram для создания ботов.
        </li>
        <li>
          Отправьте <code>/newbot</code>.
        </li>
        <li>Введите имя бота — любое, например «Мои отклики».</li>
        <li>
          Введите username: латиницей и обязательно с окончанием <code>bot</code>, например{' '}
          <code>my_jobs_tracker_bot</code>.
        </li>
        <li>
          BotFather пришлёт токен вида <code>1234567890:AAH…</code> — скопируйте его целиком и вставьте в
          поле.
        </li>
      </ol>
      <p>
        Потеряли токен — <code>/token</code> в BotFather; токен утёк — <code>/revoke</code> выдаст новый
        (старый перестанет работать, вставьте сюда новый).
      </p>
    </>
  );
}

const callback = () => `${location.origin}/api/integrations/google/callback`;

export function GoogleClientIdGuide() {
  return (
    <>
      <b>Как получить Google Client ID</b>
      <ol>
        <li>
          Откройте{' '}
          <a href="https://console.cloud.google.com/" {...ext}>
            Google Cloud Console
          </a>{' '}
          и создайте проект (вверху → «New Project», например <code>job-tracker</code>).
        </li>
        <li>
          <a href="https://console.cloud.google.com/apis/library/gmail.googleapis.com" {...ext}>
            APIs &amp; Services → Library → Gmail API
          </a>{' '}
          → <b>Enable</b>.
        </li>
        <li>
          <a href="https://console.cloud.google.com/auth/overview" {...ext}>
            Google Auth Platform (OAuth consent screen)
          </a>
          : тип <b>External</b>, название приложения и ваша почта. В <b>Audience</b> нажмите{' '}
          <b>Publish app</b> — иначе доступ к почте слетает через 7 дней.
        </li>
        <li>
          <a href="https://console.cloud.google.com/apis/credentials" {...ext}>
            Credentials
          </a>{' '}
          → <b>Create credentials → OAuth client ID</b> → тип <b>Web application</b>.
        </li>
        <li>
          В <b>Authorized redirect URIs</b> добавьте ровно этот адрес:
          <br />
          <code>{callback()}</code>
        </li>
        <li>
          <b>Create</b> → скопируйте <b>Client ID</b> (заканчивается на{' '}
          <code>.apps.googleusercontent.com</code>).
        </li>
      </ol>
      <p>
        Без проверки приложения Google при входе покажет «приложение не проверено» («Дополнительно» →
        «Перейти»), а войти смогут не больше 100 человек. Для друзей проще пароль приложения — его каждый
        вводит в блоке Gmail сам.
      </p>
    </>
  );
}

export function GoogleClientSecretGuide() {
  return (
    <>
      <b>Где взять Google Client secret</b>
      <ol>
        <li>
          Показывается в том же окне, где Client ID, сразу после <b>Create</b> — строка вида{' '}
          <code>GOCSPX-…</code>.
        </li>
        <li>
          Окно уже закрыли:{' '}
          <a href="https://console.cloud.google.com/apis/credentials" {...ext}>
            Credentials
          </a>{' '}
          → ваш OAuth client (Web application) → раздел <b>Client secrets</b> → <b>Add secret</b> и скопируйте
          новый.
        </li>
      </ol>
      <p>Сначала заполните Client ID — секрет без него не работает. Никому его не показывайте.</p>
    </>
  );
}

export function AnthropicKeyGuide() {
  return (
    <>
      <b>Как получить ключ Anthropic</b>
      <ol>
        <li>
          Войдите в{' '}
          <a href="https://console.anthropic.com/" {...ext}>
            console.anthropic.com
          </a>
          .
        </li>
        <li>
          <b>Billing</b> — пополните баланс или подключите карту: без этого ключ не работает.
        </li>
        <li>
          <a href="https://console.anthropic.com/settings/keys" {...ext}>
            Settings → API Keys
          </a>{' '}
          → <b>Create Key</b>, имя — например <code>job-tracker</code>.
        </li>
        <li>
          Скопируйте ключ (<code>sk-ant-…</code>) сразу: потом Anthropic его целиком не покажет.
        </li>
      </ol>
      <p>
        Ключ общий для всех пользователей трекера; расход каждого ограничивается лимитом в «Пользователях».
      </p>
    </>
  );
}

export function TelegramAppGuide() {
  return (
    <>
      <b>Как получить api_id и api_hash</b>
      <ol>
        <li>
          Откройте{' '}
          <a href="https://my.telegram.org/apps" {...ext}>
            my.telegram.org
          </a>{' '}
          и войдите своим номером — код придёт в приложение Telegram.
        </li>
        <li>
          <b>API development tools</b> → заполните форму: App title — например <code>Job tracker</code>, Short
          name — <code>jobtracker</code>, Platform — <b>Desktop</b>.
        </li>
        <li>
          <b>Create application</b> → скопируйте <b>App api_id</b> (число) и <b>App api_hash</b> (32 символа).
        </li>
      </ol>
      <p>
        Это «приложение» трекера, одно на всех: каждый пользователь потом входит в свой Telegram в блоке
        «Лента вакансий». Если такое приложение уже есть (например, у бота-переводчика), подойдут те же
        значения.
      </p>
    </>
  );
}
